// extracted by mini-css-extract-plugin
export default {"title":"ResetPassword_title__vvBc0","button":"ResetPassword_button__fIdHX"};